import React from 'react';
import { v4 } from 'uuid';

export default function useSequence() {
  const sequenceIdRef = React.useRef(null);

  return {
    startSequence: () => {
      const sequenceId = v4();
      sequenceIdRef.current = sequenceId;

      return sequenceId;
    },
    isSequenceStale: (sequenceId) => {
      return sequenceId !== sequenceIdRef.current;
    },
    hasSequenceStarted: () => {
      return sequenceIdRef.current !== null;
    },
    clearSequence: () => {
      sequenceIdRef.current = null;
    },
  };
}
